import { render, staticRenderFns } from "./ss11.vue?vue&type=template&id=ba166ba2&scoped=true&"
import script from "./ss11.vue?vue&type=script&lang=js&"
export * from "./ss11.vue?vue&type=script&lang=js&"
import style0 from "./ss11.vue?vue&type=style&index=0&id=ba166ba2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba166ba2",
  null
  
)

export default component.exports